import { useLocation } from '@hulu/react-router-dom';
import React from 'react';

import { DropDownItem } from '../types';
import { Card, Title, Wrapper } from './styled';

type Props = {
  list: Array<DropDownItem>;
  handleItemClick: (item: DropDownItem) => void;
};

const CustomDropDown = ({ list, handleItemClick }: Props): JSX.Element => {
  const location = useLocation();

  const onDropDownItemClick = (item: DropDownItem): void => {
    if (item.disabled) return;

    handleItemClick(item);
  };

  return (
    <Wrapper>
      <Card data-testid="customDropdown">
        {list.map((item: DropDownItem) => {
          return (
            <Title
              $disabled={item.disabled || false}
              $selected={location.pathname.includes(item.url)}
              onClick={(): void => onDropDownItemClick(item)}
              key={item.title}
              data-testid="dropdownItem"
            >
              {item.title}
            </Title>
          );
        })}
      </Card>
    </Wrapper>
  );
};

export default CustomDropDown;
